import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { fetchClients } from '../../utils/apiService';

import client1 from '../../assets/image/section-testimonial-1.jpg';

const Clients = () => {
    const [clients, setClients] = useState([]);

    useEffect(() => {
        const getClients = async () => {
            const result = await fetchClients();
            if (result && result.status && result.data) {
                // Take only the first 3 clients (backend sorts by sort_order)
                setClients(result.data.slice(0, 3));
            }
        };

        getClients();
    }, []);

    const getImageUrl = (imgVal) => {
        if (!imgVal) return client1; // Use a default or imported placeholder
        const imgStr = imgVal.toString().trim();
        return imgStr.startsWith('http')
            ? imgStr
            : `${process.env.REACT_APP_STORAGE_BASE_URL || 'http://localhost:8000/storage'}/${imgStr}`;
    };

    return (
        <section className="section-team tf-spacing-2">
            <div className="mask mask-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="700" height="700" fill="none">
                    <circle cx="350" cy="350" r="285" stroke="url(#a8)" strokeWidth="130" />
                    <defs>
                        <linearGradient id="a8" x1="154" x2="497.875" y1="61.688" y2="589.75">
                            <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
                            <stop offset="1" stopColor="#fff" stopOpacity="0" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
            <div className="tf-container">
                <div className="row">
                    <div className="col-lg-3">
                        <div className="heading-section">
                            <div className="sub-title body-2 fw-7 mb-17">
                                Our Clients
                            </div>
                            <h2
                                className="title fw-6 mb-60 title-animation"
                                dangerouslySetInnerHTML={{
                                    __html: "Some of our clients."
                                }}
                            />
                            <div className="list-btn flex align-items-center g-15">
                                <div className="scrolling-effect effectBottom">
                                    <div className="arrow-btn style-border arrow-prev team-prev">
                                        <i className="icon-arrow-left2"></i>
                                    </div>
                                </div>
                                <div className="scrolling-effect effectBottom">
                                    <div className="arrow-btn style-border arrow-next team-next">
                                        <i className="icon-arrow-right2"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-9">
                        <Swiper
                            modules={[Pagination, Navigation]}
                            spaceBetween={30}
                            slidesPerView={1}
                            pagination={{ clickable: true, el: '.sw-pagination-team' }}
                            navigation={{
                                nextEl: '.team-next',
                                prevEl: '.team-prev',
                            }}
                            className="tf-swiper sw-team sw-border"
                            breakpoints={{
                                450: { slidesPerView: 2, slidesPerGroup: 2 },
                                1200: { slidesPerView: 3, slidesPerGroup: 1 }
                            }}
                        >
                            {clients.map((client) => (
                                <SwiperSlide key={client.id}>
                                    <div className="team-item hover-image">
                                        <div className="top-item">
                                            <span className="image">
                                                <img src={getImageUrl(client.image)} alt={client.title} />
                                            </span>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div className="sw-pagination-team sw-pagination d-lg-none mt-15 justify-content-center"></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Clients;
